import React, { useState, useEffect } from "react";
import Calendar from "./calendar";
import moment from "jalali-moment";
import * as Styled from "./style";
import { isDate, getDateISO, DATE_FORMAT } from "./dateUtils";
import { CloseableArea } from "../closeableArea";
import { CustomInput } from "./components/customInput";
import { formatDateInNumbers } from "../../lib/normalizeDate";
moment.locale("fa");

export default props => {
  const [dateState, setDateState] = useState(null);
  const [calendarOpen, setCalendarOpen] = useState(false);
  let {
    input: { value, onChange },
    placeholder,
    name,
    meta
  } = props;
  const placeholderText =
    placeholder !== undefined ? placeholder : "انتخاب تاریخ";
  useEffect(() => {
    const newDate = value && new moment(value);
    isDate(newDate) && setDateState(getDateISO(newDate));
  }, []);
  useEffect(() => {
    const dateISO = getDateISO(value);
    setDateState(dateISO);
  }, [props]);
  const toggleCalendar = () => {
    setCalendarOpen(!calendarOpen);
  };
  const handleDateChange = date => {
    const newDate = date ? getDateISO(date.format(DATE_FORMAT)) : null;
    if (dateState !== newDate) {
      setDateState(newDate);
      onChange(newDate);
    }
    setCalendarOpen(false);
  };
  return (
    <Styled.Box>
      <CloseableArea show={calendarOpen} onClose={toggleCalendar} />
      <CustomInput
        value={dateState}
        placeholder={placeholderText}
        onClick={toggleCalendar}
        formatDate={value => formatDateInNumbers(value, "DD MMM YYYY")}
      />
      {calendarOpen && (
        <Styled.DatePickerDropdown onClick={toggleCalendar}>
          <Styled.DatePickerDropdownMenu onClick={e => e.stopPropagation()}>
            <Calendar
              date={(dateState && new moment(dateState)) || moment()}
              onDateChanged={handleDateChange}
              name={name}
            />
          </Styled.DatePickerDropdownMenu>
        </Styled.DatePickerDropdown>
      )}

      <i className="calendar-icon icon mapsa-calendar" />
      {meta.error && meta.error !== "" && (
        <span className="notice">{meta.error}</span>
      )}
    </Styled.Box>
  );
};
